import React from 'react';
import RadarChart from '../../charts/RadarChart';

import './MyRadar.css';

class MyRadarChart extends React.Component {

    componentDidMount() {
        const config = {
            w: this.props.style.width,
            h: this.props.style.height,
            maxValue: 100,
            levels: 5,
            ExtraWidthX: 50,
            ExtraWidthY: 60
        }

        RadarChart.draw(`#${this.props.id}`, [this.props.series], config);
    }

    render() {
        return (
            <div id={this.props.id}></div>
        );
    }
}

MyRadarChart.defaultProps = {
    id: 0,
    style: {
        width: 500,
        height: 100
    },
    data: []
};

export default MyRadarChart;


// WEBPACK FOOTER //
// ./src/components/charts/MyRadarChart.js